import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText, fmtDate } from "../lib/api";
import { Head, Card, Field, Empty, Tag } from "../components/bits";
import { useNavigate } from "react-router-dom";
import { startTour } from "../components/Tour";

export const STATUS_KIND = { open: "info", needs_human: "warn", answered: "ok", closed: "" };
export const STATUS_LABEL = { open: "AI is replying…", needs_human: "With our team", answered: "Answered", closed: "Closed" };

export function Thread({ t, onReply, testId }) {
  const [body, setBody] = useState("");
  return (
    <div data-testid={testId}>
      {t.messages.map((m) => <div key={m.id} className={`note mb-2 ${m.author === "user" ? "" : ""}`} style={{ borderLeftColor: m.author === "ai" ? "var(--gold)" : m.author === "admin" ? "var(--paper)" : "var(--line)" }}>
        <div className="flex justify-between"><b>{m.author === "ai" ? "ExperTraQ AI" : m.author === "admin" ? (m.author_name || "Support team") : (t.name || "You")}</b><span className="sub" style={{ margin: 0 }}>{fmtDate(m.created_at)}{m.delivery === "email-pending" && " · email pending"}{m.delivery === "email-sent" && " · emailed"}</span></div>
        <div className="prose" style={{ marginTop: 4 }}>{m.body}</div></div>)}
      {onReply && t.status !== "closed" && <form onSubmit={(e) => { e.preventDefault(); if (body.trim()) { onReply(body); setBody(""); } }} className="mt-3">
        <textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder="Reply…" data-testid={`${testId}-reply-input`} />
        <button className="btn sm mt-2" data-testid={`${testId}-reply-btn`}>Send reply</button></form>}
    </div>
  );
}

export default function Help() {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ subject: "", message: "" });
  const [open, setOpen] = useState(null);
  const load = () => api.get("/support/tickets").then((r) => setList(r.data));
  useEffect(() => { load(); const i = setInterval(load, 8000); return () => clearInterval(i); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/support/tickets", f); toast.success("Sent — the AI assistant usually replies within a minute"); setF({ subject: "", message: "" }); setOpen(data.id); load(); } catch (ex) { toast.error(errText(ex)); }
  };
  const reply = async (id, body) => { await api.post(`/support/tickets/${id}/messages`, { body }); load(); };
  const cur = list.find((t) => t.id === open);
  const nav = useNavigate();
  const replay = () => { nav("/today"); setTimeout(startTour, 300); };
  return (
    <div data-testid="help-page">
      <Head title="Help" sub="Ask us anything about ExperTraQ. The assistant answers straight away, and billing, legal or account-security questions go to a person. You can also email support@expertraq.com." right={<button className="btn ghost sm" onClick={replay} data-testid="replay-tour-btn">Replay the 5-step tour</button>} />
      <div className="grid g2">
        <Card title="New request" testId="help-form-card">
          <form onSubmit={submit}>
            <Field label="Subject"><input value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} required data-testid="help-subject-input" /></Field>
            <Field label="Message"><textarea value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} required style={{ minHeight: 120 }} data-testid="help-message-input" /></Field>
            <button className="btn" data-testid="help-submit-btn">Send</button>
          </form>
        </Card>
        <Card title="Your requests" testId="help-list">
          {!list.length ? <Empty testId="help-empty">No requests yet.</Empty> : list.map((t) => <div key={t.id} className="kv" style={{ cursor: "pointer" }} onClick={() => setOpen(t.id === open ? null : t.id)} data-testid={`ticket-${t.id}`}><span><b>{t.subject}</b><div className="sub" style={{ margin: 0 }}>{fmtDate(t.updated_at)} · {t.messages.length} messages</div></span><Tag kind={STATUS_KIND[t.status]} testId={`ticket-status-${t.id}`}>{STATUS_LABEL[t.status]}</Tag></div>)}
        </Card>
      </div>
      {cur && <Card className="mt-4" title={cur.subject} sub={STATUS_LABEL[cur.status]} testId="ticket-thread-card"><Thread t={cur} onReply={(b) => reply(cur.id, b)} testId="ticket-thread" /></Card>}
    </div>
  );
}
